import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';
import { globalFilterSelector } from 'utility/redux/globalFilter.selector';

const CountryRegionsData = (() => {
  const apiName = 'countryRegionOverview';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `country-management/country-region`;
  generatedHttpThunk.syntheticResponse = {};
  generatedHttpThunk.globalFilterSelector = globalFilterSelector;
  return generatedHttpThunk.generateCountryRegionThunk();
})();

export const CountryRegionMapData = (() => {
  const apiName = 'countryRegionMap';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `country-management/country-region-map`;
  generatedHttpThunk.syntheticResponse = {};
  generatedHttpThunk.globalFilterSelector = globalFilterSelector;
  return generatedHttpThunk.generateCountryRegionThunk();
})();

export const CRMSummaryData = (() => {
  const apiName = 'crmSummary';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `country-management/crm-summary`;
  generatedHttpThunk.syntheticResponse = {};
  generatedHttpThunk.globalFilterSelector = globalFilterSelector;
  return generatedHttpThunk.generateCountryRegionThunk();
})();

export const RegionSummaryData = (() => {
  const apiName = 'regionSummary';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `country-management/region-summary`;
  generatedHttpThunk.syntheticResponse = {};
  generatedHttpThunk.globalFilterSelector = globalFilterSelector;
  return generatedHttpThunk.generateCountryRegionThunk();
})();

export default CountryRegionsData;
